// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import {
  getCheckoutSteps,
  progressStepColor,
} from '../../../helpers/checkout-modal-helpers';

import { StyledModalProgressBar, ProgressBarItem } from './styled-components';

// Component
const ProgressBar = ({ data, stepId }) => {
  const checkoutSteps = getCheckoutSteps(data);
  let numItems = 0;

  checkoutSteps.forEach(step => {
    if (!step.isHidden(data) && !step.hideFromProgressBar(data)) {
      numItems += 1;
    }
  });

  return (
    <StyledModalProgressBar aria-hidden>
      { }
      {checkoutSteps.reduce((steps, step, i) => {
        if (!step.isHidden(data) && !step.hideFromProgressBar(data)) {
          const title = step.alternateProgressTitle(data) || step.progressTitle;
          steps.push(
            <ProgressBarItem
              key={step.progressTitle}
              color={progressStepColor(stepId, i)}
              width={`${100 / numItems}%`}
            >
              {title}
            </ProgressBarItem>,
          );
        }
        return steps;
      }, [])}
    </StyledModalProgressBar>
  );
};

ProgressBar.propTypes = {
  data: PropTypes.object,
  stepId: PropTypes.number,
};

export default ProgressBar;
